export const INITIAL = 'INITIAL';
export const START = 'START';
export const IN_PROGRESS = 'IN_PROGRESS';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const INFO = 'INFO';
export const WARNING = 'WARNING';
